import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Services from "../home/components/Services";
import OnlineServices from "../home/components/OnlineServices";
import { useSelector } from "react-redux";
import ServicePlaceholder from "./components/ServicePlaceholder";

const Service = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [service, setService] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/services/detail/${params.slug}/`
      )
      .then((res) => {
        setService(res.data);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [params]);

  return (
    <div className="service-page pt-5">
      <div className="container">
        <div className="row">
          {isLoading === true ? (
            <ServicePlaceholder />
          ) : (
            <>
              <div
                className={`col-lg-8 col-md-10 col-sm-12 col-xs-12 ${
                  service.extra_tm === null || service.extra_tm === ""
                    ? "m-auto"
                    : ""
                }`}
              >
                <h4
                  className=""
                  style={{
                    textAlign: "left !important",
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "20px",
                  }}
                >
                  {lang === "en"
                    ? service.name_en
                    : lang === "ru"
                    ? service.name_ru
                    : service.name_tm}
                </h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "en"
                        ? service.content_en
                        : lang === "ru"
                        ? service.content_ru
                        : service.content_tm,
                  }}
                ></div>
              </div>
              {service.extra_tm === null || service.extra_tm === "" ? (
                ""
              ) : (
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "en"
                          ? service.extra_en
                          : lang === "ru"
                          ? service.extra_ru
                          : service.extra_tm,
                    }}
                  ></div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {service !== null && service.is_online === true ? (
        <OnlineServices />
      ) : (
        <Services />
      )}
    </div>
  );
};

export default Service;
